import styled from 'styled-components';
import SquereProgress from './SquereProgress';
import { IThisUserState } from '../../store/thisUser/thisUserSlice';
import { ITask } from '../../store/tasks/tasksType';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { gray, lightGrayBackground } from '../../utils/style/colors';

interface UserProgressProps {
  user: IThisUserState;
  task?: ITask;
  canChangeProgress?: boolean;
  onSetAssigneeIdToShow?: (asId: number | null) => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0 0.5rem;
  background: ${lightGrayBackground};
  border-radius: 1rem;
  padding-inline-start: 0.5rem;
  cursor: pointer;
  // border: 1px solid ${gray};
`;

const AssigneeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
  justify-content: stretch;
  padding-top: 0.1rem;
`;

const Header = styled.h5`
  font-weight: bold;
  font-size: 0.8rem;
`;

const Content = styled.div`
  font-size: 0.6rem;
`;

const UserProgress: React.FC<UserProgressProps> = ({
  user,
  task,
  onSetAssigneeIdToShow,
}) => {
  const { t } = useTranslation('taskManager');
  const userTaskInfo = task?.assignee[Number(user.userId)];

  return (
    <Container
      onClick={() => {
        if (userTaskInfo) onSetAssigneeIdToShow?.(Number(user.userId));
      }}
    >
      <AssigneeInfo>
        <Header>{user.name}</Header>
        <Content>
          {userTaskInfo?.progress === 0
            ? task?.assigneeNotStartedTitle || t('notStarted')
            : userTaskInfo?.progress === 100
              ? task?.assigneeCompleteTitle || t('complete')
              : task?.assigneeStartedTitle || t('started')}
        </Content>
      </AssigneeInfo>
      <SquereProgress
        isProgressive={task?.type === 'progressive' ? true : false}
        progress={userTaskInfo?.progress || 0}
        size={37}
      />
    </Container>
  );
};

export default UserProgress;
